
import styles from "./SurveyPage.module.scss";
import { Button, Layout } from "components";
import { useEffect, useState } from "react";
import Notification from "utils/Notifications";
import { PostSurvey } from "service/SurveyService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import SurveyBody from "./components/SurveyBody";
import { getSurveyData, getSurveyUserData, getSurveyUserAll } from "service/SurveyService";
import rewIcon from "assets/icons/pdf.png";
import filerew from 'assets/files/📝_Руководство_по_использованию_сервиса_анкетирования.pdf'
const SurveyPage = () => {
  const [activeTab, setActiveTab] = useState('available');
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const [userdata, setDataForUser] = useState([]);
  const [usedata, setData2] = useState([]);

  const getData = async () => {
    try {
      let response = await getSurveyData(data);
      setData(response.data);

    } catch (error) {
      console.log("CHU")
    }
  };

  const getDataForUser = async () => {
    try {
      let response = await getSurveyUserData(data);
      setDataForUser(response.data);
    } catch (error) {
      console.log("CHU")
    }
  };
  const getDataForUserAll = async () => {
    try {
      let response_user_data = await getSurveyUserAll(data);
      setData2(response_user_data.data)
    } catch (error) {
      console.log("CHU")
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: "Введите наименование анкетирования!",
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      // formData.append('title',title);
      formData.append('title', body);


      let testsinfo = await PostSurvey(formData);

      getData();

      setBody("");
      setOpenModal(false)
      setNotify({
        isOpen: true,
        message: "Анкетирование успешно создан!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {
    getData();
    getDataForUser();
    getDataForUserAll();
    setRender(false)

  }, [render]);
  return (
    <Layout>
      <div className={styles["test-block"]}>
        <div className={styles["tabs"]}>
          {/* Buttons for switching tabs */}
         
          <button
            className={styles.tab_btn}
            onClick={() => setActiveTab('available')}
          >
            Доступные анкетировании <h3 className={styles.h3_3h}>{userdata?.length ? userdata?.length : 0}</h3>
          </button>
          <button
            className={styles.tab_btn}
            onClick={() => setActiveTab('completed')}
          >
            Пройденные <h3 className={styles.h3_3h}>{usedata?.length ? usedata?.length : 0}</h3>
          </button>
          <button
            className={styles.tab_btn}
            onClick={() => setActiveTab('create')}
          >
            Констуктор <h3 className={styles.h3_3h}>{data?.length ? data?.length : 0}</h3>
          </button>
          <a href={filerew} download className={styles.sign__rew__btn}>
                    Руководство <img style={{ width: "25px" }} src={rewIcon} alt="" />
                  </a>
        </div>
        {activeTab === 'create' && (
          <>
          <div className={styles["test-app"]}>
            <h2>Конструктор анкетировании</h2>
            <Button
              className="create__statement__btn"
              onClick={() => setOpenModal(true)}
            >
              Создать анкетирование
            </Button>
          
          </div>
          <SurveyBody data={data} isadmin={true} />
          </>
        )}

        {activeTab === 'available' && (
          <>
            <div className={styles["test-app"]}>
              <h2>Доступные анкетировании</h2>
              <h2>{userdata?.length ? userdata?.length : 0}</h2>

            </div>
            <SurveyBody data={userdata} isadmin={false} />
          </>
        )}

        {activeTab === 'completed' && (
            <>
          <div className={styles["test-app"]}>
            <h2>Пройденные</h2>
            <h2>{usedata?.length ? usedata?.length : 0}</h2>
            
          </div>
          <SurveyBody data={usedata} isadmin={false} log={0} />
          </>
        )}

        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={'Введите название анкетирования'}
        >
          <>
            <div className={styles["note-input"]}>
            
              <form onSubmit={handleSubmit} >
              
                <input
                  type="text"
                  placeholder="Введите название анкетирования:"
                  className={styles.type_input}
                  value={body}
                  name="body"
                  onChange={(e) => setBody(e.target.value)}
                />

                <div className={styles.create_footer}>


                  <button
                    type="submit"
                    className={styles.open_btn_sub}

                  >
                    Создать
                  </button>
                </div>
              </form>
            </div>
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.close_btn_sub}
            >
              {" "}
              Закрыть
            </Button>
          </>
        </ModalWindow>
        <Notification notify={notify} setNotify={setNotify} />
      </div>
    </Layout>
  );
};

export default SurveyPage;
